import Image from "next/image";
import React from "react";
import { useTranslation } from "../../context/TranslationContext";

const Unconditionalmoney = () => {
  const {
    UnconditionalmoneyTitle,
    UnconditionalmoneySubTitle,
    UnconditionalmoneyDescription,
    UnconditionalmoneyDescription2,
  } = useTranslation();
  return (
    <div className="guest-protection-gradiend lg:mb-44 mb-16 overflow-hidden">
      <div className="guest-adam-image relative">
        <div className="container flex lg:items-start items-center lg:justify-start justify-center absolute top-1/2 lg:w-full left-0 -translate-y-1/2 xl:ml-[9.281rem]">
          <div className="flex sm:flex-nowrap flex-wrap sm:items-start items-center sm:justify-start justify-center sm:text-start text-center bg-white xl:w-1/2 md:w-3/4 w-full xl:py-16 sm:py-10 py-4 xl:pr-36 sm:pr-16 pr-4 sm:pl-11 pl-4">
            <div className="flex mr-6 flex-shrink-0">
              <div className="object-contain  w-24 h-24 relative">
                <Image
                  alt=""
                  src="/images/guest-protection-image.jpeg"
                  layout="fill"
                />
              </div>
            </div>
            <div className="flex flex-col">
              <div className="flex flex-col sm:mb-12 mb-4">
                <span className="text-text-securePayment sm:text-[2rem] text-25 font-bold leading-[2.4rem]">
                  {UnconditionalmoneyTitle}
                </span>
                <span className="text-dark sm:text-[2rem] text-25 font-bold leading-[2.4rem]">
                  {UnconditionalmoneySubTitle}
                </span>
              </div>
              <div className="flex flex-col">
                <span className="font-normal text-13 opacity-50 tracking-[0.031rem] pb-4">
                  {UnconditionalmoneyDescription}
                </span>
                <span className="font-normal text-13 opacity-50 tracking-[0.031rem] text-text-securePayment2 border-b-2 border-text-securePayment2 pb-8">
                  ({UnconditionalmoneyDescription2})
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unconditionalmoney;
